import { createPortal } from "react-dom"
import styled from "styled-components"
import { Button, Modal } from "@prosolve/common-components-ui"
import { FaSyncAlt } from "react-icons/fa"
import { formatDateTime, formatDuration, getJobId } from "./jobUtils"
import { MutedText, StatusBadge } from "./JobTable"

const HistoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  max-height: calc(100vh - 250px);
  width: 720px;
  max-width: calc(100vw - 80px);
  overflow: auto;
`

const HistoryItem = styled.div`
  border: ${({ theme }) => theme.borders.main};
  border-radius: ${({ theme }) => theme.borderRadius.main};
  padding: 10px;
`

const ColumnGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const RowGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const CodeBlock = styled.pre`
  max-height: 140px;
  overflow: auto;
  margin: 8px 0 0;
  padding: 8px;
  border-radius: ${({ theme }) => theme.borderRadius.main};
  background: ${({ theme }) => theme.backgrounds.main};
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 10px;
`

export default ({
  job,
  history,
  isLoading,
  onRefresh,
  onClose
}) => {
  const footer = (
    <ButtonsContainer>
      <Button onClick={onRefresh}>
        <RowGroup>
          <FaSyncAlt />
          Refresh
        </RowGroup>
      </Button>
      <Button $colored={true} onClick={onClose}>
        Close
      </Button>
    </ButtonsContainer>
  )

  return createPortal(
    <Modal
      title={`Run History - ${job.name}`}
      isAutoHeight={true}
      isAutoWidth={true}
      onClose={onClose}
      footer={footer}
    >
      <HistoryList>
        {isLoading && <MutedText>Loading history...</MutedText>}
        {!isLoading && history?.length > 0 && history.map(historyItem => (
          <HistoryItem key={getJobId(historyItem)}>
            <ColumnGroup>
              <RowGroup style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <StatusBadge $status={historyItem.status}>{historyItem.status}</StatusBadge>
                <MutedText>{formatDateTime(historyItem.startedAt)}</MutedText>
              </RowGroup>
              <MutedText>
                {historyItem.trigger} run
                {historyItem.statusCode ? `, HTTP ${historyItem.statusCode}` : ''}
                {historyItem.durationMs || historyItem.durationMs === 0 ? `, ${formatDuration(historyItem.durationMs)}` : ''}
              </MutedText>
              {historyItem.error &&
                <CodeBlock>{historyItem.error}</CodeBlock>
              }
              {!historyItem.error && historyItem.responseBody &&
                <CodeBlock>{historyItem.responseBody}</CodeBlock>
              }
            </ColumnGroup>
          </HistoryItem>
        ))}
        {!isLoading && (!history || history.length === 0) &&
          <MutedText>No runs have been recorded for this job.</MutedText>
        }
      </HistoryList>
    </Modal>,
    document.body
  )
}
